<div *nzModalTitle class="px-0 py-1 w-full">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data.nzTitle}}</p>
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
    <app-loader></app-loader>
    }
    @else{
        @if(plainRawMaterials && plainRawMaterials.length > 0) {
            @if(useAssess && useSensors){
                <div class="block p-4">
                    <div nz-row nzJustify="start" [nzGutter]="{ xs: 16, sm: 16, md: 24, lg: 32 }" class="pb-4">
                        @for (rawMaterial of plainRawMaterials; track rawMaterial; let idx = $index) {
                        <long-press-btn
                            [duration]="1000"
                            [ngClass]="{
                                'bg-green-500 hover:bg-green-600': rawMaterial.isLoadedOnMachine,
                                'bg-gray-500 hover:bg-gray-600': !rawMaterial.isLoadedOnMachine
                            }"
                            class="text-white rounded-lg shadow-md mb-4 mx-3 w-[240px] min-h-[180px] flex flex-col p-4 transition-all duration-200 hover:shadow-lg [&>.progress-button]:!block [&>.progress-button]:!text-left [&>.progress-button]:!items-start"
                            (longPress)="onLongPressed(rawMaterial)" (tap)="openScanRawMaterialModal(rawMaterial)">

                            <div class="flex flex-col h-full w-full">
                                <div class="mb-3 pb-3 border-b border-white/20">
                                    @if (rawMaterial.articleFamily) {
                                        <p class="text-[13px] leading-tight text-center break-words mb-1">
                                            {{ rawMaterial.articleFamily }}
                                        </p>
                                        <div class="border-b border-white/20 my-1"></div>
                                    }
                                    <p class="text-[13px] leading-tight break-words">
                                        {{ rawMaterial.article?.name }}
                                    </p>
                                </div>

                                <div class="space-y-2 text-[13px]">
                                    @if (rawMaterial.articleBatch) {
                                        <div class="flex items-center gap-1">
                                            <span class="font-semibold text-white/70 text-[11px]">Lote:</span>
                                            <span class="break-words">{{ rawMaterial.articleBatch.batchNumber }}</span>
                                        </div>
                                    }

                                    @if (rawMaterial.packaging) {
                                        <div class="flex items-center gap-1">
                                            <span class="font-semibold text-white/70 text-[11px]">Formato:</span>
                                            <span class="break-words">
                                                {{ rawMaterial.packaging.externalBatchNumber || rawMaterial.packaging.batchNumber }}
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </long-press-btn>
                        }
                    </div>
                </div>
            }@else {
                <nz-table #basicTable [nzData]="plainRawMaterials" class="m-0 p-0" nzSize="small" [nzLoading]="isLoading"
                    nzTableLayout="auto" [nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="false"
                    [nzScroll]="{ y: (tableHeight || 0) + 'px' }">
                    <thead>
                        <tr>
                            <th id="article">Artículo</th>
                            <th id="batch">Lote</th>
                            <th id="packaging">Formato</th>
                            <th id="quantity">Cantidad consumida</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (rawMaterial of basicTable.data; track rawMaterial; let idx = $index) {
                        <tr>
                            <td>
                                {{ rawMaterial.article?.name }}
                            </td>
                            <td>
                                {{ rawMaterial.articleBatch ? rawMaterial.articleBatch.batchNumber : '-' }}
                            </td>
                            <td>
                                {{ rawMaterial.packaging ? rawMaterial.packaging.packagingType?.name + ' ' +
                                (rawMaterial.packaging.externalBatchNumber || rawMaterial.packaging.batchNumber) : '-'}}
                            </td>
                            <td>
                                {{ rawMaterial.quantity | number:'1.2-2'}} {{ rawMaterial.measurementUnit }}
                            </td>
                        </tr>
                        }
                    </tbody>
                </nz-table>
            }
        }
        @else {
            <div class="w-full h-full content-center">
                <nz-empty></nz-empty>
            </div>
        }
    }
</div>

<div *nzModalFooter>
    @if(useAssess && useSensors){
        <div class="flex">
            <p>
                <i>Nota: Mant&eacute;n pulsado sobre una materia prima para abrir el men&uacute; de acciones.</i>
            </p>
        </div>
    }
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button mr-2">
            Cancelar
        </button>
    </div>
</div>
